export default __webpack_public_path__ + "static/media/team-hero.55aca726.png";